module.exports = __webpack_public_path__ + "img/zhao.64f0f908.png";